import { createFetcher } from '../../Common';

import { queryBuilder } from '../../utils';

import { getBaseUrl, SKILLS_ENDPOINT } from '../../constants';

export class Skills {
  static getInstance() {
    if (!this.instance) {
      this.instance = new Skills(createFetcher());
    }
    return this.instance;
  }

  constructor(fetcher) {
    this.endpoint = SKILLS_ENDPOINT;
    this.fetcher = fetcher;
  }

  get base_url() {
    return getBaseUrl();
  }

  async getAllSkill(req) {
    const queryString = queryBuilder(req);
    const url = `${this.base_url}${this.endpoint}${queryString}`;
    const response = await this.fetcher.getData(url);
    return { data: response?.data, meta: response?.meta };
  }

  async getSkillById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.getData(url);
    return response?.data;
  }

  async putSkillById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.putData(url, req.reqBody);
    return response?.data;
  }

  async postSkill(reqBody) {
    const url = `${this.base_url}${this.endpoint}`;
    const response = await this.fetcher.postData(url, reqBody);
    return response?.data;
  }

  async deleteSkillById(req) {
    const url = `${this.base_url + this.endpoint}/${req.reqId}`;
    const response = await this.fetcher.deleteData(url, req.reqBody);
    return response;
  }
}

export const createSkills = () => Skills.getInstance();
